import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface AgentRuntimeData {
  status: string;
  log: string;
  error: string;
  attributes: {
    label: string;
    value: number;
  }[];
  output: string;
}

export function useGetAgentRuntime(agentUuid: string, runUuid: string | null, runtimeVersion: number) {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['agentRuntime', agentUuid, runUuid],
    queryFn: async (): Promise<AgentRuntimeData> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/get_agentrun`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ agentUuid, runUuid }),
        }
      );

      const data = await response.json();

      return data?.data?.runtimeStatus;
    },
    refetchInterval: (data) => {
      if (!!runUuid && data?.status === 'running' && runtimeVersion < 3) {
        return 1000;
      }

      return false;
    },
    enabled: !!runUuid,
    cacheTime: 0,
    staleTime: 0,
  });
}
